import { useEffect } from 'react';

import { getWfaBreadcrumbRoutes } from 'src/apps/wfa/helpers/WfaDashboardHelpers';
import { usePermissions } from 'src/common/hooks/usePermissions';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

export const useSetWfaBreadcrumbs = (sessionId: string, sessionName: string): void => {
	const { updateBreadcrumbRoutes, setBreadcrumbRoutes } = useBreadcrumbStore();
	const isPlatformEnabledForWfa = usePermissions(ProductType.WEB_FLOW_ANALYZER);

	useEffect(() => {
		const webWfaBreadcrumbs = getWfaBreadcrumbRoutes(sessionId, sessionName);
		updateBreadcrumbRoutes(isPlatformEnabledForWfa ? webWfaBreadcrumbs : []);

		return () => {
			setBreadcrumbRoutes([]);
		};
	}, [
		updateBreadcrumbRoutes,
		setBreadcrumbRoutes,
		sessionId,
		sessionName,
		isPlatformEnabledForWfa
	]);
};
